import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PaymentService from "../../services/paymentService";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators, State } from "../../state/index";
import authService from "../../services/authService";
export const PaymentSuccess = () => {
  const [isSuccess, setIsSuccess] = useState(false);
  const token: any = useQuery().get("token");
  const paymentTransactionId: any = useQuery().get("paymenttransactionid");
  const [isLoading, setIsLoading] = useState(true);

  // Redux
  const dispatch = useDispatch();
  const { updateUserRoles } = bindActionCreators(
    actionCreators.authActions,
    dispatch
  );

  useEffect(() => {
    if (token && paymentTransactionId) {
      console.log(token);
      console.log(paymentTransactionId);
      savePayment();
    }
  }, [token, paymentTransactionId]);

  const getAndUpdateUserRoles = async () => {
    const response = await authService.getUserRoles();
    console.log(response);
    dispatch(updateUserRoles(response.data));
  };
  const savePayment = async () => {
    try {
      const response = await PaymentService.savePayment({
        token: token,
        paymentTransactionId: paymentTransactionId,
      });
      if (response.status === 200) {
        setIsSuccess(true);
        getAndUpdateUserRoles();
      }
      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);
      console.dir(e);
    }
  };

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const spinner = (
    <div>
      <div className="d-flex justify-content-center ">
        <div className="spinner-border spinner" role="status"></div>
      </div>
      <div
        style={{ marginTop: "1.5%" }}
        className="d-flex justify-content-center"
      >
        <p style={{ fontStyle: "oblique" }}>Loading...</p>
      </div>
    </div>
  );

  return (
    <div>
      {isLoading && spinner}
      <h1>{!isLoading && (isSuccess ? "Success" : "Fail")}</h1>
    </div>
  );
};
